import React, { useEffect, useState } from 'react'
import DefaultCard from '../../../../components/default/DefaultCard'
import DefaultModal from '../../../../components/default/DefaultModal';
import useSurveyService from '../../../../app/services/hooks/useSurveyService';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { SurveyDataForm, SurveyFilters } from '../../../../app/models/Survey';
import SurveyDataTable from '../../../Surveys/components/tables/SurveyDataTable';
import useReactConfirmAlert from '../../../../hooks/useReactConfirmAlert';
import useNavigationPage from '../../../../hooks/useNavigationPage';
import useUserResponseService from '../../../../app/services/hooks/useUserResponseService';
import { UserResponse } from '../../../../app/models/UserResponse';
import { isAFutureDate } from '../../../../helpers';


interface Props {
    eventId: number;
    eventTypeId?: number;
    calendarDate: string | Date;
    workerId: number;
}

interface ButtonProps {
    confirmButton?: any;
    cancelButton?: any;
    updateButton?: any;
}

const CalendarChecklistContainer = ({eventId, eventTypeId, calendarDate, workerId }: Props) => {

    const { getSurveyByEventTypeId, fetchingGetSurveyByEventType } = useSurveyService();
    const { getInProgressUserResponsesBySurvey,
        getUserResponsesByDateAndWorker, 
        fetchingGetInProgressUserResponsesBySurvey,
        fetchingUserResponsesByDateAndWorker } = useUserResponseService();
    const { navigationPage } = useNavigationPage();

    const isAfter =  isAFutureDate(calendarDate)
    

    const [surveys, setSurveys] = useState<SurveyDataForm[]>([]);
    const [userResponses, setUserResponses] = useState<UserResponse[]>([]);
    const [userResponsesSurveys, setUserResponsesSurveys] = useState<SurveyDataForm[]>([]);
    const [totalRows, setTotalRows] = useState(0);
    const [filter, setFilter] = useState<SurveyFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc',
        event_id: eventId
    });

    useEffect(()=>{
        reloadTable()
    },[filter.page, filter.per_page, filter.sort, filter.order, eventTypeId])

    useEffect(()=>{
        getUserResponsesByDateAndWorker(workerId, calendarDate.toString(), {
            onSuccess: (response: ServiceResponse) => {
                setUserResponses(response.data.user_responses);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    },[calendarDate, workerId])

    useEffect(()=>{
        if(userResponses.length > 0 && surveys.length > 0){

            surveys.forEach((survey) => {

                const matchingResponses = userResponses.find(
                    (response) => response?.survey?.id === survey.id
                );
                survey.user_response_data = matchingResponses;
            });

            setUserResponsesSurveys(surveys)
        } else{
            setUserResponsesSurveys(surveys)
        }
    },[ userResponses, surveys ])

    const reloadTable = () => {
        if(eventTypeId){
            getSurveyByEventTypeId(eventTypeId, filter, {
                onSuccess: (response: ServiceResponse) => {
                    setSurveys(response.data.surveys);
                    setTotalRows(response.data.total_rows);
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            });
        }
    }
    
    const respondSurvey = (surveyId: number) => {
        let _text = 'Está a punto de responder la encuesta #' + surveyId;

        

        if(isAfter) return
        
        let buttons: ButtonProps = {
            confirmButton: {
                label: 'Si, confirmar',
                onClick: () => {
                    navigationPage('/surveys/' + surveyId + '/respond?date=' + calendarDate.toString());
                }
            },
            cancelButton: {
                label: 'Cancelar',
                onClick: () => {
                    setTimeout(() => {
                        useReactConfirmAlert().infoAlert({
                            title: 'Cancelado',
                            message: 'La encuesta no se ha contestado.'
                        });
                    }, 0);
                }
            }
        }

        getInProgressUserResponsesBySurvey(surveyId, calendarDate.toString(),{
            onSuccess: (response: ServiceResponse) => {
                if(response.data.user_responses.length > 0){
                    const userResponseId = response.data.user_responses[0].id
                    _text = 'Existe una encuesta en progreso para esta fecha, desea continuarla'
                    buttons = {
                        ...buttons,
                        confirmButton: {
                            label: 'Sí, Continuar Encuesta en Progreso',
                            onClick: () => {
                                navigationPage('/surveys/' + userResponseId + '/respond?user_response=true&date=' + calendarDate.toString());
                            }
                        },
                        updateButton: {
                            label: 'No, Comenzar Nueva',
                            onClick: () => {
                                navigationPage('/surveys/' + surveyId + '/respond?date=' + calendarDate.toString());
                            }
                        }
                    }
                }
                const requestConfirmationProps = {
                    title: 'Responder Encuesta',
                    message: _text,
                    buttons: buttons
                };

                buttons.updateButton 
                    ? useReactConfirmAlert().requestConfirmationMulti(requestConfirmationProps)
                    : useReactConfirmAlert().requestConfirmation(requestConfirmationProps);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });


    };

    return (
        <>
            <DefaultCard>
                <div className="row">
                    <h5>Encuestas</h5>
                    <div className="col-12">
                        <SurveyDataTable
                            surveys={userResponsesSurveys}
                            totalRows={totalRows}
                            loading={fetchingGetSurveyByEventType}
                            hideActive={true}
                            edit={!isAfter ?  respondSurvey : undefined}
                            // showResponses={showResponses}
                            filter={filter}
                            setFilter={setFilter}
                            callbackSuccess={reloadTable}
                            onSearch={reloadTable}
                            isShow={false}
                        />
                    </div>
                </div>
            </DefaultCard>
        </>
    )
}

export default CalendarChecklistContainer
